import { lazy } from 'react'

export const ArticleCreateContainerLazy = lazy(
	() => import('Pages/knowledge/articles/containers/ArticleCreate')
)
export const ArticleEditContainerLazy = lazy(
	() => import('Pages/knowledge/articles/containers/ArticleEdit')
)
export const ArticlePreviewContainerLazy = lazy(
	() => import('Pages/knowledge/articles/containers/ArticlePreview')
)
export const ArticleViewContainerLazy = lazy(
	() => import('Pages/knowledge/articles/containers/ArticleView')
)
export const ArticlesSearchContainerLazy = lazy(
	() => import('Pages/knowledge/articles/components/ArticlesSearch')
)
export const VideoEditComponentLazy = lazy(
	() => import('Pages/knowledge/articles/containers/VideoEdit/index')
)
